
export const UnsubscribedColors = {
  border: "#EAECF0",
  headerText: "#000",
  headerBg: "#F9FAFB",
  cardBg: "#FFFFFF",
  btnText: "#FFFFFF",
}

export const StartedPlanColors = {
  border: "#8098F9",
  headerText: "#8098F9",
  headerBg: "#E0EAFF",
  cardBg: "#F5F8FF",
  btnBg: "#E0EAFF",
  btnText: "#8098F9",
};

export const EssentialPlanColors = {
  border: "#17B26A",
  headerText: "#55ce87",
  headerBg: "#c5fae175",
  cardBg: "#cae4d84d",
  btnBg: "#55ce87",
  btnText: "#FFFFFF",
};

export const EssentialPlusPlanColors = {
  border: "#9B8AFB",
  headerText: "#9B8AFB",
  headerBg: "#dcd6ff70",
  cardBg: "#f2f0fe4d",
  btnBg: "#9B8AFB",
  btnText: "#FFFFFF",
};

export const AppFeaturesConstants = {
   MANDATORY_TABS : "MANDATORY_TABS",
   STARTER : "STARTER",
   ESSENTIALS: "ESSENTIALS",
   ESSENTIALS_PLUS: "ESSENTIALS_PLUS",
   CURRENT_PLAN: "Current Plan",   
}

export const PricePlan = {
  monthly: {
    STARTER: 29,
    ESSENTIALS: 59,
    ESSENTIALS_PLUS: 99
  },
  yearly: {
    STARTER: 270,
    ESSENTIALS: 560,
    ESSENTIALS_PLUS: 950
  },
}

export const PlanCurrency = {
  code: "gbp",
  symbol: "£",
}

export const getPlanTabDisplayName = (displayName = "") => {
  const name = displayName.toLowerCase().replace(/&/g, "and").trim();
  if (name.includes("about us") || name === "about") return "About Us";
  if (name.includes("contact us") || name === "contact") return "Contact Us";
  if (name.includes("experience")) return "Experiences of Work";
  if (
    name.includes("video carousel") ||
    name.includes("app carousel") ||
    name === "app"
  ) {
    return "App Carousel";
  }
  return displayName;
};

/** Stable key for matching AI missing-tab names to tab config display names. */
export const getCanonicalTabName = (displayName = "") => {
  const name = displayName.toLowerCase().replace(/&/g, "and").trim();
  if (name.includes("map advert")) return "map advert";
  if (
    name.includes("video carousel") ||
    name.includes("app carousel") ||
    name === "app"
  ) {
    return "video carousel";
  }
  if (name.includes("about us") || name === "about") return "about us";
  if (name.includes("contact us") || name === "contact") return "contact us";
  if (name.includes("team")) return "teams & roles";
  if (name.includes("experience")) return "experiences of work";
  if (name.includes("product")) return "products";
  if (name.includes("service")) return "services";
  if (name.includes("event")) return "events";
  if (name.includes("course")) return "courses";
  if (name.includes("contract")) return "contracts";
  if (name.includes("why work")) return "why work for us";
  if (name.includes("vacanc")) return "vacancies";
  if (name.includes("apprentice")) return "apprenticeships";
  if (name.includes("blog") || name.includes("news")) return "blog";
  if (name.includes("press")) return "in the press";
  return name;
};

